export default {
  sm: `
  We provide a foundation that enables easy 
  storage and fast analysis for a large-scale 
  data, for the technologies required for the 
  4th industrial revolution. This creates new 
  values and contributes to creative 
  innovations, making our lives more 
  convenient.
  `,
  lg: `
  We provide a foundation that enables easy storage 
  and fast analysis for a large-scale data, for the 
  technologies required for the 4th industrial 
  revolution. This creates new values and 
  contributes to creative innovations, making our 
  lives more convenient.
  `,
  xxl: `
  We provide a foundation that enables easy storage and fast 
  analysis for a large-scale data, for the technologies required for 
  the 4th industrial revolution. This creates new values and 
  contributes to creative innovations, making our lives more 
  convenient.
  `
};
